var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import { useVerticalExternalTimelineProcessController, } from "../../../../useVerticalTimelineProcessController";
export function TimelineDescriptionDotExamResult(_a) {
    var data = _a.data, step = _a.step;
    var findExamResult = useVerticalExternalTimelineProcessController({
        data: data,
    }).findExamResult;
    var examResult = useMemo(function () { var _a; return (_a = findExamResult(step.key)) === null || _a === void 0 ? void 0 : _a.resultado; }, [findExamResult, step.key]);
    return (_jsxs("div", __assign({ className: "flex gap-1" }, { children: [_jsx("span", __assign({ className: "text-sm" }, { children: "resultado: " })), _jsx("span", __assign({ className: "text-sm font-semibold" }, { children: examResult }))] })));
}
